import React from 'react'
import BaseBatchConsultList  from 'ui/views/batch/BaseConsultList'
import { BATCH_STATUS } from 'utils/constants/batchStatus'

export default function () {
  const title = 'Processando'
  const subtitle = 'Lotes processando'
  const status = BATCH_STATUS.processing

  return (
    <BaseBatchConsultList
      title={title}
      subtitle={subtitle}
      status={status}
    />
  )
}
